import {BUSCAR_LOCALIZACAO_VEICULO} from '../../actions/types'

const initialState = undefined

export default function reducerBuscarLocalizacaoVeiculo(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_LOCALIZACAO_VEICULO: {
            return action.payload.data;
        }
        default: {
            return state
        }
    }
}
